import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';

interface SeparatorListProps {
  $spacing?: number;
}

export const SeparatorList = styled.ul<SeparatorListProps>`
  list-style: none;
  padding: 0;
  margin: calc(var(--_separator-list-spacing, ${size(1.5)}) * -1) 0;

  ${({ $spacing }) =>
    $spacing &&
    css`
      --_separator-list-spacing: ${size($spacing)};
    `}
`;

export const SeparatorListItem = styled.li`
  padding: var(--_separator-list-spacing, ${size(1.5)}) 0;

  & + & {
    border-top: 1px solid var(--c-border-main);
  }
`;

export const SeparatorListItemSpaceBetween = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${size(2)};
  font-size: ${(props) => props.theme.font.size.small};
`;
